import * as React from 'react';
import { updateMktoActivity } from '../ta-services/ta-user-service';
import { prettifyImgUrl } from '../ta-services/ta-utils';
import { TaQuestionData, WIX_ANSWERS_LOGO_BLACK } from '../ta-shared';
import { TaQuestionBox } from './ta-questions-box/comp';
import { TaQuestionsPreview } from './ta-questions-preview/comp';

type TaQuestionsPageProps = {
	step: number;
	questionsData: TaQuestionData[];
	onUserAnswer: (value?: string) => void;
};

export class TaQuestionsPage extends React.PureComponent<TaQuestionsPageProps> {
	handleDrop = async (ev: any) => {
		await updateMktoActivity('DROP');
		return (ev.returnValue = 'Are you sure you want to close?');
	}

	componentDidMount () {
		window.scroll(0, 0);
		window.addEventListener('beforeunload', this.handleDrop, true);
	}

	componentWillUnmount () {
		window.removeEventListener('beforeunload', this.handleDrop, true);
	}

	handleUpdateStep = (value?: string) => {
		this.props.onUserAnswer(value);
	}

	renderComp = () => {
		const { step, questionsData } = this.props;
		if (!step || step > 17) {
			return <TaQuestionsPreview onUpdateStep={this.handleUpdateStep} />;
		} else {
			return (
				<div className='ta-questions-container'>
					<div className='ta-questions'>
						<div className='ta-questions-subject'>
							<span>
								<img
									src={prettifyImgUrl(questionsData[step - 1].subjectIcon)}
									alt='Icon'
								/>
							</span>
							<span>{questionsData[step - 1].subject}</span>
						</div>
						<TaQuestionBox
							currentQuestion={questionsData[step - 1]}
							onUpdateStep={this.handleUpdateStep}
						/>
					</div>
					<div className='ta-questions-logo'>
						<img
							src={WIX_ANSWERS_LOGO_BLACK}
							alt='Wix Answers logo'
						/>
					</div>
				</div>
			);
		}
	}

	render () {
		return (
			<div className='ta-questions-page-container'>
				{this.renderComp()}
			</div>
		);
	}
}
